import { removeDupes, cleanObject } from '../utils/helpers';

const getGroupKey = payload => {
    if (payload.taskId) {
        return 'task';
    }

    if (payload.userId) {
        return 'user';
    }

    if (payload.projectId) {
        return 'project';
    }

    return null;
}

const getIDFromPayload = payload => payload.taskId || payload.userId || payload.projectId;


const timeTracking = (state = {
    items: [],
    fetchInfo: {
        user: {},
        task: {},
        project: {}
    }
}, action) => {
    switch (action.type) {
        case 'TIME_ENTRIES_FETCH_REQUESTED':
            if ((!action.payload.type || action.payload.type === 'all')) {
                const key = getGroupKey(action.payload);

                return Object.assign({}, state, {
                    fetchInfo: {
                        ...state.fetchInfo,
                        [key]: {
                            ...state.fetchInfo[key],
                            [getIDFromPayload(action.payload)]: {
                                fetched: false,
                                loading: true
                            }
                        }
                    }
                });
            }

            return state;

        case 'TIME_ENTRIES_FETCH_FAILED':
            if ((!action.payload.type || action.payload.type === 'all')) {
                const key = getGroupKey(action.payload);

                return Object.assign({}, state, {
                    fetchInfo: {
                        ...state.fetchInfo,
                        [key]: {
                            ...state.fetchInfo[key],
                            [getIDFromPayload(action.payload)]: {
                                fetched: false,
                                loading: false,
                                error: true
                            }
                        }
                    }
                });
            }

            return state;

        case 'TIME_ENTRIES_FETCH_SUCCEEDED': {
            let fetchInfo = state.fetchInfo;

            if ((!action.payload.type || action.payload.type === 'all')) {
                const key = getGroupKey(action.payload);

                fetchInfo = {
                    ...state.fetchInfo,
                    [key]: {
                        ...state.fetchInfo[key],
                        [getIDFromPayload(action.payload)]: {
                            fetched: true,
                            loading: false,
                            hasMore: action.payload.hasMore
                        }
                    }
                }
            }

            return Object.assign({}, state, {
                items: removeDupes([...action.payload.timeEntries, ...state.items]),
                fetchInfo
            });
        }

        case 'TIME_ENTRY_START_REQUESTED':
        case 'TIME_ENTRY_START_SOCKET':
        case 'TIME_ENTRY_ADD_SOCKET':
            return Object.assign({}, state, {
                items: removeDupes([...state.items, action.payload.timeEntry])
            });

        case 'TIME_ENTRY_START_FAILED':
            return Object.assign({}, state, {
                items: state.items.filter(timeEntry => timeEntry !== action.payload.fragment)
            });

        case 'TIME_ENTRY_START_SUCCEEDED':
            return Object.assign({}, state, {
                items: state.items
                    .filter(timeEntry => timeEntry.id !== action.payload.timeEntryId)
                    .map(timeEntry => {
                        if (timeEntry === action.payload.fragment) {
                            return Object.assign({}, timeEntry, {
                                id: action.payload.timeEntryId
                            });
                        }

                        return timeEntry;
                    })
            });

        case 'TIME_ENTRY_STOP_REQUESTED':
        case 'TIME_ENTRY_STOP_SOCKET':
            if (!state.items.some(timeEntry => timeEntry.id === action.payload.timeEntryId)) {
                return Object.assign({}, state, {
                    items: removeDupes([...state.items, action.payload.timeEntry])
                });
            }

            return Object.assign({}, state, {
                items: [...state.items
                    .map(timeEntry => {
                        if (timeEntry.id === action.payload.timeEntryId) {
                            return Object.assign({}, timeEntry, {
                                end: new Date().getTime()
                            });
                        }

                        return timeEntry;
                    })]
            });

        case 'TIME_ENTRY_UPDATE_REQUESTED':
        case 'TIME_ENTRY_UPDATE_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(timeEntry => {
                    if (timeEntry.id === action.payload.timeEntryId) {
                        return Object.assign({}, timeEntry, cleanObject(action.payload.timeEntryProps || action.payload.timeEntry));
                    }

                    return timeEntry;
                })
            });

        case 'TIME_ENTRY_REMOVE_REQUESTED':
        case 'TIME_ENTRY_REMOVE_SOCKET':
            return Object.assign({}, state, {
                items: state.items.filter(timeEntry => timeEntry.id !== action.payload.timeEntryId)
            });

        default:
            return state;
    }
}

export default timeTracking;
